
export enum CONFIGURATION_TYPE {
    STAMP_FILE = 'STAMP_FILE'
}